import {gql} from '@apollo/client';
import {LibraryPlaylistWithSongs} from '../../../../../../graphql/LibraryPlaylistWithSongsFragment';
import {CatalogPlaylistWithSongs} from '../../../../../../graphql/CatalogPlaylistWithSongsFragment';

export const PLAYLIST_VIEW_QUERY = gql`
  query PlaylistViewQuery($id: String!) {
    me {
      library {
        playlist(id: $id) {
          ...LibraryPlaylistWithSongsFragment
        }
      }
    }
  }
  ${LibraryPlaylistWithSongs.libraryPlaylist}
`;

export const CATALOG_PLAYLIST_VIEW_QUERY = gql`
  query CatalogPlaylistViewQuery($id: String!) {
    music {
      playlist(playlistId: $id) {
        ...CatalogPlaylistWithSongsFragment
      }
    }
  }
  ${CatalogPlaylistWithSongs.catalogPlaylist}
`;
